/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mascot_GreetInputs */

const en_mascot_greet = /** @type {(inputs: Mascot_GreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Say hello to the KerjaBareng mascot`)
};

const id_mascot_greet = /** @type {(inputs: Mascot_GreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sapa maskot KerjaBareng`)
};

/**
* | output |
* | --- |
* | "Say hello to the KerjaBareng mascot" |
*
* @param {Mascot_GreetInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mascot_greet = /** @type {((inputs?: Mascot_GreetInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mascot_GreetInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mascot_greet(inputs)
	return en_mascot_greet(inputs)
});